import { render, staticRenderFns } from "./MeterCommunityRateChart.vue?vue&type=template&id=38df7b27&scoped=true"
import script from "./MeterCommunityRateChart.vue?vue&type=script&lang=js"
export * from "./MeterCommunityRateChart.vue?vue&type=script&lang=js"
import style0 from "./MeterCommunityRateChart.vue?vue&type=style&index=0&id=38df7b27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df7b27",
  null
  
)

export default component.exports